import { Box } from "@mui/material";
import { ChevronRight } from "lucide-react";
import { ReactComponent as Star } from "../../../assets/kid_star.svg";
import "./ReelElement.scss";

export default function ReelElement({
  information,
  clickEvent,
  successCaseClick,
}: any) {
  const defaultImage = "../../../assets/success_cases_bg.jpg";
  const imageBackground = information.image_url;

  return (
    <Box className="elementContainer">
      <Box className="elementContainer__header">
        <img
          className="success-cases__content__ideas__row__item-image"
          src={imageBackground || defaultImage}
        />
        <Box className="elementContainer__header__icon">
          <Star
            className="star"
            onClick={() => successCaseClick(information)}
          />
        </Box>
      </Box>
      <Box
        onClick={() => clickEvent(information)}
        className="elementContainer__body"
      >
        <Box className="elementContainer__body__unit">
          {information.hospitalUnits}
        </Box>
        <Box className="elementContainer__body__title">{information.title}</Box>
        <Box className="elementContainer__body__description">
          {information.description}
        </Box>
        <Box
          className="elementContainer__body__icon"
          onClick={() => clickEvent(information)}
        >
          <ChevronRight />
        </Box>
      </Box>
    </Box>
  );
}
